import { insertIf, join } from 'lib/helpers';

import styles from 'components/account/account.module.css';

interface Props {
  label: string;
  value?: string | null;
  color?: 'default' | 'green' | 'amber' | 'red';
}

const SummaryField = ({ label, value, color = 'default' }: Props) => (
  <p>
    {label}:{' '}
    <span
      className={join([
        styles.Value,
        ...insertIf(color === 'green', styles.Green),
        ...insertIf(color === 'amber', styles.Amber),
        ...insertIf(color === 'red', styles.Red),
      ])}
    >
      {value ?? '—'}
    </span>
  </p>
);

export default SummaryField;
